import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/karpito/metall-service.kiev.ua/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/karpito/metall-service.kiev.ua/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/karpito/metall-service.kiev.ua/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/karpito/metall-service.kiev.ua/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/karpito/metall-service.kiev.ua/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/karpito/metall-service.kiev.ua/src/components/blocks/ScrollToTopButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/karpito/metall-service.kiev.ua/src/components/blocks/SubscribeForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/karpito/metall-service.kiev.ua/src/components/blog/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/karpito/metall-service.kiev.ua/src/components/blog/PostContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/karpito/metall-service.kiev.ua/src/components/blog/RelatedPosts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogMDXProvider"] */ "/home/karpito/metall-service.kiev.ua/src/mdx/MDXProvider.tsx");
